import '@/styles/common/Preview/preview.scss';

import React, { useEffect, useMemo, useState, VFC } from 'react';

import { PreviewPage } from '@/components/CareerHistory/';
import { CareerHistory, Status, UserInfo } from '@/utils/api-client/api';
export type TFetchDataProps = {
  user: UserInfo | null;
  fetchData: (CareerHistory & Status & UserInfo) | undefined;
};

export const CareerHistoryConfirmationPreview: VFC<TFetchDataProps> = ({ user, fetchData }) => {
  const type = 'input_agency';
  const [scale, setScale] = useState<number>(1);
  const [height, setHeight] = useState<number>(1188);

  useEffect(() => {
    const mbxPreviewPage = document.getElementsByClassName('mbx-preview-page')[0];
    if (!mbxPreviewPage) return;
    const mbxPreviewPageWidth = mbxPreviewPage.getBoundingClientRect().width;
    const mbxPreviewContent = document.getElementsByClassName('mbx-preview')[0];
    const aspectRatio = mbxPreviewPage.getBoundingClientRect().height / mbxPreviewPageWidth;
    const resizeObserver = new ResizeObserver(() => {
      const mbxPreviewContentWidth = mbxPreviewContent.getBoundingClientRect().width;
      if (window.innerWidth < 1024) {
        setScale(mbxPreviewContentWidth / mbxPreviewPageWidth);
        if (!isNaN(aspectRatio)) setHeight(mbxPreviewContentWidth * aspectRatio);
      } else {
        setScale(1);
        if (!isNaN(aspectRatio)) setHeight(mbxPreviewPageWidth * aspectRatio);
      }
    });
    resizeObserver.observe(window.document.body);
    return () => resizeObserver.unobserve(window.document.body);
  }, []);

  const date = useMemo<string>(() => {
    if (!fetchData?.latest_update) return '';
    const dateAry = fetchData?.latest_update.split('-');
    return `${dateAry[0]}年${dateAry[1]}月${dateAry[2]}日`;
  }, [fetchData]);

  return (
    <div className="mbx-preview mbx-utils-stack-v--preview">
      <PreviewPage
        scale={scale}
        height={height}
        date={date}
        fetchData={fetchData}
        user={user}
        type={type}
      />
    </div>
  );
};
